export enum ApiErrorsCodes {
  NotFound = 'not_found',
  NotValid = 'not_valid',
  UnknownError = 'unknown_error',
}
export enum ApiErrors {
  NotFound = 'Ресурс не найден',
  NotValid = 'Проверьте правильность передаваемых значений',
  UnknownError = 'Произошла непредвиденная ошибка',
  IncorrectAuth = 'Некорректные учетные данные',
}

export enum ValidationErrors {
  Required = 'Обязательное поле',
  NotNumber = 'Должно быть числом',
  IncorrectEmailFormat = 'Проверьте правильность введенного e-mail',
  Incorrect = 'Некорректное значение',
  IncorrectGranularity = 'Гранулярность KPI меньше, чем гранулярность проекта',
  MinOneChain = 'Нужно добавить хотя бы одну цепочку',
  MinOneCoordinator = 'Нужно добавить хотя бы одного согласующего',
  RepeatCoordinator = 'Согласующий повторяется в цепочке',
  RepeatPlannerInRow = 'Переданный планёр не может быть согласующим',
  RepeatPlanner = 'Цепочка с этим планёром уже существует',
  NotIntegerNumber = 'Должно быть целым числом',
}

export enum Success {
  Save = 'Сохранено',
  UserCreated = 'Пользователь успешно добавлен',
  ProjectCreated = 'Проект успешно добавлен',
  GroupCreated = 'Группа успешно добавлена',
  TemplateCreated = 'Шаблон успешно добавлен',
  FieldCreated = 'Поле успешно добавлено',
  BusinessTypeCreated = 'Бизнес-тип успешно добавлен',
  PromoGroupCreated = 'Промо: группа успешно добавлена',
  PromoPeriodCreated = 'Промо: период успешно добавлен',
  PromoSettingConstraintCreated = 'Промо: ограничение успешно добавлено',
  PromoSettingHierarchyLevelCreated = 'Промо: уровень иерархии успешно добавлен',
  PromoSettingTargetVariableCreated = 'Промо: параметр целевой функции успешно добавлен',
  RtmGroupCreated = 'RTM: группа успешно добавлена',
  RtmParametersCreated = 'RTM: параметр оптимизации успешно добавлен',
  TetrisGroupCreated = 'TETRIS: группа успешно добавлена',
  CfrGroupCreated = 'CFR: группа успешно добавлена',
}

export enum Info {
  UserRemoved = 'Пользователь удален',
  ProjectRemoved = 'Проект удален',
  GroupRemoved = 'Группа удалена',
  TemplateRemoved = 'Шаблон удален',
  FieldRemoved = 'Поле удалено',
  BusinessTypeRemoved = 'Бизнес-тип удален',
  PromoGroupRemoved = 'Промо: группа успешно удалена',
  PromoPeriodRemoved = 'Промо: период успешно удален',
  PromoSettingConstraintRemoved = 'Промо: ограничение удалено',
  PromoSettingHierarchyLevelRemoved = 'Промо: уровень иерархии удален',
  PromoSettingTargetVariableRemoved = 'Промо: параметр целевой функции удален',
  RtmGroupRemoved = 'RTM: группа успешно удалена',
  RtmParametersRemoved = 'RTM: параметр оптимизации  успешно удален',
  TetrisGroupRemoved = 'TETRIS: группа успешно удалена',
  CfrGroupRemoved = 'CFR: группа успешно удалена',
}

export enum ErrorsNoData {
  Languages = 'Не удалось загрузить языки',
  Hosts = 'Не удалось загрузить список хостов',
  Endpoints = 'Не удалось загрузить список эндпойнтов',
  Engines = 'Не удалось загрузить список ML-движков',
  DataSourceFields = 'Не удалось загрузить список полей шаблонов',
}
